"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _PageForSitemap = _interopRequireDefault(require("./PageForSitemap"));

var _constants = require("./constants");

var _handleActions;

var initialState = (0, _immutable.fromJS)({});

function getUpdatedState(state, action, filter) {
  var pages = action.payload.data.objects;
  var domain = action.payload.props.domain;
  return state.setIn([domain, filter], (0, _immutable.List)(pages.map(function (page) {
    return new _PageForSitemap.default(page);
  })));
}

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchIncludedPagesForSitemapActionTypes.SUCCESS, function (state, action) {
  return getUpdatedState(state, action, _constants.INCLUDED_FILTER);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchExcludedPagesForSitemapActionTypes.SUCCESS, function (state, action) {
  return getUpdatedState(state, action, _constants.EXCLUDED_FILTER);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;